// Configuracion para servidor API
/*****PRODUCCIÓN*****/
export const Rutas = 'http://apiclientes.grupogestoriapastor.com/index.php/api/';

/*****PRE-PRODUCCIÓN*****/
//export const Rutas = 'http://apiclientespre.grupogestoriapastor.com/index.php/api/';

/*****DESARROLLO*****/
//export const Rutas =  'http://apiclientespre2.grupogestoriapastor.com/index.php/api/';

/*****LOCAL*****/
//export const Rutas = 'http://localhost:8000/index.php/api/';

//export const Rutas = 'http://192.230.30.69/index.php/api/';

/*****OLD*****/
//export const Rutas = 'https://apipastor.avanzaconsultoria.com/api/';
//export const Rutas = 'http://apiclientes.server.local/api/';
//export const Rutas = 'http://127.0.0.1:8000/api/';

//ng build --output-path distpre --output-hashing all
